import { useQuery } from "@tanstack/react-query";
import { FirestoreError } from "firebase/firestore";
import { useParams } from "react-router-dom";
import { QUERY_KEY } from "@/modules/grupos-diagnostico/components/grupos-diagnostico-table/GruposDiagnosticoTable";
import { getGrupoArray } from "@/modules/grupos-diagnostico/firestore";
import useUserStore from "@/modules/users/store";

type TGetGroupResponse = Awaited<ReturnType<typeof getGrupoArray>>;

/**
 * Get ideia from url params
 * @returns - Ideia or null if not found
 */
function useQueryGroup() {
  const activeEmpresaId = useUserStore((state) => state.activeEmpresaId);
  const { id } = useParams<{ id: string; idProjeto: string }>();

  return useQuery<TGetGroupResponse, FirestoreError, TGruposDiagnostico[]>({
    queryKey: [QUERY_KEY, id, activeEmpresaId],
    queryFn() {
      if (!activeEmpresaId) {
        throw new Error("Empresa não selecionada");
      }
      if (!id) {
        throw new Error("Nenhum questionario");
      }

      return getGrupoArray(activeEmpresaId, id);
    },
    select(dataResponse) {
      if (dataResponse.empty) {
        return [];
      }

      return dataResponse.docs.map((document_) => document_.data());
    },
    enabled: !!id && !!activeEmpresaId
  });
}

export default useQueryGroup;
